import { batch } from 'react-redux';
import { getMemberVerify } from 'Api/SheerIdService';
import { localStorageGet, localStorageSet, localStorageRemove } from 'Utils/Storage';
import {
  SET_BANGO,
  CLEAR_INTEGRATIONS,
  SET_INITIAL_SHEER_STEP,
  SET_REDIRECT_URL,
  CLEAR_SHEER_ID,
  SET_SHEER_PROGRAM,
  SET_SHEER_VERIFICATION_ID,
} from '../Types';

// action creators
export const setBango = (payload) => ({ type: SET_BANGO, payload });
export const resetIntegrations = () => ({ type: CLEAR_INTEGRATIONS });
export const setInitialStep = () => ({ type: SET_INITIAL_SHEER_STEP });
export const setRedirectUrl = (payload) => ({ type: SET_REDIRECT_URL, payload });
export const setSheerProgram = (payload) => ({ type: SET_SHEER_PROGRAM, payload });
export const setSheerVerificationId = (payload) => ({ type: SET_SHEER_VERIFICATION_ID, payload });
export const clearSheerId = () => ({ type: CLEAR_SHEER_ID });

// action thunks

//bango
export const checkBangoParams = () => (dispatch) => {
  const windowUrl = window?.location?.search?.replace('\\u0026', '&');
  const query = new URLSearchParams(windowUrl);
  const subscriptionId = query.get('subscriptionRequestId') || localStorageGet('subscriptionRequestId') || '';
  const redirectUrl = query.get('redirect_uri') || localStorageGet('redirect_uri') || '';
  const productId = query.get('productId') || localStorageGet('productId') || '';

  if (subscriptionId) {
    localStorageSet('subscriptionRequestId', subscriptionId);
    localStorageSet('redirect_uri', redirectUrl);
    localStorageSet('productId', productId);
    return dispatch(setBango({ subscriptionId, redirectUrl, productId }));
  }
};

export const addRedirectUrl = (redirectUrl) => (dispatch) => {
  localStorageSet('redirect_uri', redirectUrl);
  return dispatch(setRedirectUrl(redirectUrl));
};

//sheerid
export const getUserSheerInfo = () => async (dispatch) => {
  const response = await getMemberVerify();

  batch(() => {
    dispatch(setSheerVerificationId(response.verificationId));
    dispatch(setSheerProgram(response.program));
  });
  return response;
};

export const clearIntegrations = () => (dispatch) => {
  localStorageRemove('subscriptionRequestId');
  localStorageRemove('redirect_uri');
  localStorageRemove('productId');
  dispatch(resetIntegrations());
};
